import React from 'react';

import type { NextPage } from 'next';
import { type NextFont } from 'next/dist/compiled/@next/font';
import { DM_Sans } from 'next/font/google';
import Image from 'next/image';
import Link from 'next/link';

import { PageContainer } from '../components/index';
const dmSans = DM_Sans({
  weight: ['400', '500', '700'],
  subsets: ['latin'],
  display: 'swap'
});

const theconnectedmagazine: NextPage<{ inter: NextFont }> = ({ inter }) => (
  <PageContainer>
    <section className={`${dmSans.className} lg:p-16 p-8 flex flex-col gap-6`}>
      <div className="flex lg:flex-row flex-col gap-8 ">
        <div className="flex flex-col gap-6 items-center lg:items-start">
          <h2
            className={`relative w-fit text-2xl md:text-3xl font-medium after:absolute after:left-1 after:-bottom-2 after:mx-auto after:h-1 after:inset-x-0 lg:after:right-auto lg:after:ml-0 lg:after:w-5/12 after:w-9/12 after:rounded-full after:bg-golden lg:text-4xl ${inter.className}`}
          >
            Honorary Award
          </h2>
          <p className="w-full lg:text-xl text-lg text-justify font-light leading-[30px]">
            The Connected Awards is committed to recognizing and celebrating the
            achievements of tech personalities globally. The honorary tech
            personality award is one of the ways that the brand shows
            appreciation to individuals who have made significant contributions
            to the growth and development of technology. Our brand encourages
            tech experts to continue pushing beyond the boundaries of what is
            possible in the tech industry, and it promises to continue to
            recognize and celebrate their achievements.
          </p>
        </div>
        <Image
          src="/honorary/award-1.png"
          alt="Honorary Award"
          width={572}
          height={419}
          className="lg:w-2/5 w-full h-auto lg:basis-2/5"
          priority
        />
      </div>
      <div className="flex gap-8 lg:my-12 my-6 flex-row-reverse ">
        <div className="flex flex-col gap-6 items-center lg:items-start">
          <h2
            className={`relative w-fit text-2xl md:text-3xl font-medium after:absolute after:left-1 after:-bottom-2 after:h-1 lg:after:w-5/12 after:mx-auto after:inset-x-0 lg:after:right-auto lg:after:ml-0 after:w-9/12 after:rounded-full after:bg-golden lg:text-4xl ${inter.className}`}
          >
            The Criteria
          </h2>
          <p className="w-full lg:text-xl text-lg text-justify font-light leading-[30px]">
            The Connected Awards recognizes outstanding tech personalities
            globally and has new criteria for its honorary tech personality
            award. To be considered for the honorary award, tech experts must
            have over six (6) years of traceable working experience. In
            addition, the tech expert must showcase significant impacts towards
            the growth of technology in his region or globally. It means that
            the expert must have made notable contributions to the development
            and advancement of technology, which must have impacted his country
            or the global tech community. The selection process is rigorous and
            transparent to ensure that only the most outstanding tech experts
            are recognized.
          </p>
          <p className="w-full lg:text-xl text-lg text-justify font-light leading-[30px]">
            To win the honorary tech personality award, tech experts must gather
            at least 6,000 support (attestation units). This ensures the award is not just a
            recognition of technical expertise but also a recognition of
            community support and impact.
          </p>
        </div>
        <Image
          src="/honorary/award-2.png"
          alt="Honorary Award"
          width={525}
          height={419}
          priority
          className="w-2/5 h-auto basis-2/5 hidden lg:block"
        />
      </div>
      <div className="flex flex-col items-center">
        <h2
          className={
            'relative w-fit text-xl md:text-3xl font-medium lg:text-4xl lg:text-left text-center'
          }
        >
          Will you like to win an honorary award?
        </h2>
        <div className="w-fit mx-auto">
          <Link
            href="mail:hello@theconnectedawards.com"
            className="text-golden"
          >
            Send us a message
          </Link>
          , to win an honorary award
        </div>
      </div>
    </section>
  </PageContainer>
);

export default theconnectedmagazine;
